import { render, staticRenderFns } from "./SettingsView.vue?vue&type=template&id=b62ba522&lang=pug&"
import script from "./SettingsView.vue?vue&type=script&lang=ts&"
export * from "./SettingsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports